export default __webpack_public_path__ + "static/media/priority_normal.f33ecd22.svg";